import forgotPasswordDialogTemplate from './ForgotPasswordDialog.html';

/*******************************************************************************
 * Dialog for sending a new password to a user's email.
 *******************************************************************************/
export function ForgotPasswordDialogDirective(ClickDialogDirective) {
  return new ClickDialogDirective({
    template: forgotPasswordDialogTemplate,
    size: 'lg',
    controller: Controller
  });
}

ForgotPasswordDialogDirective.$inject = ['ClickDialogDirective'];

/*******************************************************************************
 * Controller
 *******************************************************************************/
function Controller($injector, $scope) {
  var $svcs = { $ctrl: this, $injector, $scope };

  $injector.invoke(initCtrl, null, Object.assign($svcs, { $svcs }));
}

Controller.$inject = ['$injector', '$scope'];

/*******************************************************************************
 * initCtrl */
/**
 * Initializes the controller object.
 *******************************************************************************/
/* @ngInject */ function initCtrl($ctrl, $injector, $svcs, LABELS_FORGOT) {
  Object.assign($ctrl, {
    validators: {},
    focusEmail: true,
    labels: angular.copy(LABELS_FORGOT),
    send: $injector.invoke(send, null, $svcs)
  });
}

initCtrl.$inject = ['$ctrl', '$injector', '$svcs', 'LABELS_FORGOT'];

/*******************************************************************************
 * $ctrl.send */
/**
 * Sends confirmation email with instructions to continue the reset process.
 *******************************************************************************/
/* @ngInject */ function send(
  $ctrl,
  Alert,
  BusyScreen,
  LABELS_RESET,
  LoginConstants,
  SystemLoginServices
) {
  return function () {
    if (!$ctrl.validators.validate()) return;

    BusyScreen.promise(
      SystemLoginServices.resetPassword($ctrl.email).then(
        function () {
          Object.assign($ctrl.labels, angular.copy(LABELS_RESET), {
            body: `${LABELS_RESET.body} ${LoginConstants.resetPasswordMsg}`
          });
          $ctrl.resetSuccessful = true;
        },
        function (resp) {
          Alert.error(resp.parsedResponse.message());

          /*-------------------------------------------*/
          /* Reset flag before setting again to ensure */
          /* the change is actually seen by csm-focus. */
          /*-------------------------------------------*/
          $ctrl.focusEmail = false;
          $ctrl.focusEmail = true;
        }
      )
    );
  };
}

send.$inject = [
  '$ctrl',
  'Alert',
  'BusyScreen',
  'LABELS_RESET',
  'LoginConstants',
  'SystemLoginServices'
];
